export const ErrorCode = {
  UNKNOWN_ERROR: 0,
  VOUCHER_NOT_FOUND: 2001,
  VOUCHER_ALREADY_SELECTED: 2003,
  MINIMUM_DAYS_AHEAD: 3002,
  CREDIT_CARD_ERROR: "creditCardError",
  TERMS_AND_CONDITIONS_ERROR: "termsAndConditionsError",
};
